<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "SiteVendorCategories",
  data() {
    return {};
  },
};
</script>
